export const blobToJson = async <T extends object>(blob: Blob): Promise<Awaited<T>> =>
  JSON.parse(await blob.text());

export const fileDownloadByUrl = (url: string, name: string) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  anchor.click();
};

export const fileDownloadByBlob = (blob: Blob, name: string) => {
  const url = URL.createObjectURL(blob);
  fileDownloadByUrl(url, name);
  URL.revokeObjectURL(url);
};

export const getSingleFileByFileSelector = (accept?: string) => {
  return new Promise<File | null>((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = false;
    input.accept = accept ?? '';
    input.onchange = (() => {
      const file = getSingleFile(input.files);
      resolve(file);
    });
    input.click();
  });
};

export const getSingleFile = (data?: FileList | null) => {
  if (!(data instanceof FileList) || data.length === 0) return null;
  return data[0];
};
